export default __webpack_public_path__ + "static/media/img16.0df09015.jpg";